import {Injectable} from '@angular/core';
import {environment} from "../../../environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {TenantService} from "./tenant.service";
import {User} from "../models/user.model";
import {ApiResponse} from "../utils/api-util";
import {SearchResult} from "../models/response.model";
import {LocalStorage} from "./storage.service";

@Injectable({
  providedIn: 'root'
})
export class UserService {

  API = `${environment.apiUrl}/user`;

  /** User */
  @LocalStorage('user', User)
  user: User;

  /**
   * @param http - to call api
   * @param tenantService
   */
  constructor(private http: HttpClient,
              private tenantService: TenantService) {
  }

  /**
   * Calls api to search for users based on query
   *
   * @param query
   * @param skip
   * @param count
   */
  @ApiResponse(SearchResult, User)
  async search(query: string, skip = 0, count = 10): Promise<SearchResult<User>> {
    const params = new HttpParams()
      .set('tenantId', this.tenantService.tenant.tenantId.toString())
      .set('query', query)
      .set('skip', skip.toString())
      .set('count', count.toString());
    return await this.http.get<SearchResult<User>>(`${this.API}/search`, {params}).toPromise();
  }

  /**
   * Creates new user
   *
   * @param user
   * @param pass
   * @param pin
   */
  @ApiResponse(User)
  async create(user: User, pass: string, pin: string): Promise<User> {
    const body = {
      ...user,
      password: pass,
      pin: pin
    };
    return await this.http.post<User>(`${this.API}/register`, body).toPromise();
  }

  /**
   * Updates user data based on its `userId`
   *
   * @param user
   */
  @ApiResponse(User)
  async update(user: User): Promise<User> {
    return await this.http.post<User>(`${this.API}/update`, user).toPromise();
  }

  /**
   * Calls api to delete user based on its `userId`
   *
   * @param user
   */
  @ApiResponse(User)
  async delete(user: User): Promise<User> {
    return await this.http.delete<User>(`${this.API}/delete/${user.userId}`).toPromise();
  }

  /**
   * Calls api to get available mentors based on tenant id
   */
  @ApiResponse([User])
  async getMentors(): Promise<User[]> {
    const params = new HttpParams()
      .set('tenantId', this.tenantService.tenant.tenantId.toString());
    return await this.http.get<User[]>(`${this.API}/mentors`, {params}).toPromise();
  }


}
